import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ui from '@nuxt/ui/vue-plugin';
import { configure } from 'vue-gtag';
import router from '@/routes/router';
import Configuration from '@/models/configuration.model';
import useTrack from '@/composables/use-track';
import BaseApplication from './base-application.vue';
import '@/styles/application.css';

const configuration = new Configuration(import.meta.env.MODE);
configure({
  tagId: configuration.ga4MeasurementId,
  config: !configuration.isProduction ? { debug_mode: true } : {},
});

const app = createApp(BaseApplication);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(ui);

// Initialize Tracking
useTrack().init(app);

app.mount('#application');
